import { TFunction } from '@lyearn/i18n';
import { ActionMenuProps } from '@lyearn/molecules';
import { ALL_FIELDS } from '@/modules/corporate/modules/database/fields';

export const getAddSurveyBlockItems = (t: TFunction): ActionMenuProps['items'] => [
  { type: 'label', label: t('SurveyEditor:SurveyElements') },
  ...ALL_FIELDS.map(({ type, labelKey, Icon }) => ({
    id: type,
    StartIcon: Icon,
    label: t(labelKey),
  })),
];
